import { parse as parseJSON5 } from 'json5'
import { MARKDOWN_PLUGIN_URL } from './envVariables'

const PLUGIN_RE =
  /~(?<path>[^?\\]+)(?<sep>\?)(?<json>\{.*?\})~/gs

const ESCAPED_PLUGIN_RE =
  /~(?<path>[^?\\]+)\\(?<sep>\?)(?<json>\{.*?\})~/gs
//                   ^---- Question mark escaped by a backslash (\?)

//--------------------------------------------------------------------------------
/**
 * Replace plugin markup with the output of the corresponding plugins.
 */
export async function fillMarkdownPlugins(markdownText: string): Promise<string> {

  // Actual markup: fetch every plugin in parallel, then splice back in document order
  const matches = [...markdownText.matchAll(PLUGIN_RE)]
  const replacements = await Promise.all(
    matches.map(async (m) => {
      const { path, json } = m.groups as { path: string; json: string }
      try {
        const data = parseJSON5(json)
        return await renderPlugin(path, data)
      } catch (err) {
        console.error(`Error parsing plugin tag: ${err}`, json)
        return m[0]
      }
    })
  )

  let out = ''
  let last = 0
  for (let i = 0; i < matches.length; i++) {
    const m = matches[i]!
    const idx = m.index ?? 0
    out += markdownText.slice(last, idx)
    out += replacements[i]!
    last = idx + m[0].length
  }
  out += markdownText.slice(last)
  markdownText = out

  // Escaped markup (\? before JSON)
  markdownText = markdownText.replace(
    ESCAPED_PLUGIN_RE,
    (_match, path: string, sep: string, json: string) =>
      `~${path}${sep}${json}~`
  )

  return markdownText
}

//--------------------------------------------------------------------------------
/** Execute remote call to fetch plugin content */
async function renderPlugin(path: string, data: unknown): Promise<string> {
  let url = path
  if (url.startsWith('/'))
    url = MARKDOWN_PLUGIN_URL + url

  url += '?' + JSON.stringify(data)

  const response = await fetch(url)
  if (!response.ok) {
    const text = await response.text()
    console.error(`Failed to fetch plugin: ${response.statusText}`, url)
    return `[ERROR ${response.status}]\n<!--\n\n${text}\n\n-->\n`
  }

  const text = await response.text()
  return text
}
